define([
    "dojo/_base/declare",
    "csi/state/rootStore",
    "csi/table/New",
    "csi/wizard/ActionControllerMixin",
    "csi/xml",
    "csi/xml/Query",
    "csi/reflection",
    "./StructureItemMixin",
    "SiteAdmin/SelectSet/SelectSetForm"
], function(declare,{ routerStore },New,ActionControllerMixin,xml,Query,reflection,StructureItemMixin) {

    return declare([New, ActionControllerMixin, StructureItemMixin], {

            getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
                // summary: filter nodes by structure item
                var q = this.inherited(arguments);

                switch (index) {
                    case 0:
                        this.subtype = view.subType;
                        break;
                    case 1: {
                        q = new Query();
                        const { locationUrl } = routerStore;
                        switch (view.defView.m_id) {
                            case "AllApparelBOMs" :
                                this.subtype = "centric://REFLECTION/INSTANCE/SelectSetSubtype/ApparelBOM";
                                var path = reflection.PATH_PARENT;
                                q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl, path); break;
                            case "Colorways" :
                                this.subtype = "centric://REFLECTION/INSTANCE/SelectSetSubtype/Colorway";
                                q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl); break;
                            case "AllSKUs" :
                                this.subtype = "centric://REFLECTION/INSTANCE/SelectSetSubtype/SKU";
                                q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl); break;
                            case "AllStyles" :
                                this.subtype = "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style";
                                q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl); break;
                            case "SupplierItems" :
                                this.subtype = "centric://REFLECTION/INSTANCE/SelectSetSubtype/StyleSupplierItem";
                                var path = reflection.PATH_PARENT + "/" + reflection.PATH_PARENT + "/" + reflection.PATH_PARENT;
                                q.RefAttr(this._resolveViewRelation(this.widget), xml.OP_EQUALS, locationUrl, path);
                                break;
                        }
                        break;
                    }
                }

                return q;
            },

            onNextPage: function(/*csi.wizard.Widget*/wizard,
                             /*csi.wizard.Content*/currentPage,
                             /*csi.wizard.Content*/nextPage,
                             /*Boolean*/bFinish) {
                // summary: prepare the data and pass it into the next page
                var fd = this.m_formData;
                var bRefresh = false;
                return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;

            },

            toWriter: function() {
                // summary: set values to email message
                var call = this.inherited(arguments);

                call.addParameter("Subtype", xml.ATTR_REF, this.subtype);
                call.addParameter("CreatedAt", xml.ATTR_REF, routerStore.locationUrl);

                return call;
            }

    });
});
